import WithRender from "../../templates/tables/otherOptionsTable.html";

export default WithRender({
  computed: {
    name: () => {
      return "Others";
    }
  }
});
